import "../App.css";
import { Link } from 'react-router-dom';

function Home() {
    return (
        <section className="relative overflow-hidden px-4 sm:px-6 md:px-10 lg:px-16 pt-24 md:pt-28 pb-10 md:pb-14">
            <div className="hero-blob hero-blob-one" />
            <div className="hero-blob hero-blob-two" />

            <div className="relative max-w-6xl mx-auto grid lg:grid-cols-[1.35fr_1fr] gap-8 md:gap-12 items-center">
                <div className="space-y-6">
                    <p className="text-sm md:text-base uppercase tracking-[0.2em] text-slate-700 font-semibold">Lukas Brillant - Portfolio 2026</p>

                    <h1 className="text-4xl sm:text-5xl lg:text-6xl font-black leading-[1.05] text-slate-900">
                        Full-stack student developer building practical products for real users.
                    </h1>

                    <p className="text-base md:text-lg text-slate-700 max-w-xl leading-relaxed">
                        I am a second-year Computer Science student in France, curious and autonomous. Alongside my degree,
                        I build concrete full-stack projects and I am looking for a work-study position to apply these skills in production.
                    </p>

                    <div className="flex flex-wrap gap-3 pt-1">
                        <Link to="/projects" className="home-cta-primary">
                            Explore Projects
                        </Link>
                        <Link to="/parcours" className="home-cta-secondary">
                            View Parcours
                        </Link>
                    </div>
                </div>

                <div className="landing-panel">
                    <h2 className="text-xl md:text-2xl font-bold text-slate-900">Quick Profile</h2>
                    <ul className="space-y-3 text-slate-700 mt-4">
                        <li>Location: Caen, France.</li>
                        <li>Driving license: Category B (not currently vehicle-equipped).</li>
                        <li>Native language: French.</li>
                        <li>English: C1, TOEIC 985/990.</li>
                    </ul>
                    <div className="mt-7 pt-5 border-t border-slate-300/80">
                        <p className="text-sm uppercase tracking-[0.18em] font-semibold text-slate-500">Contact</p>
                        <p className="text-lg font-semibold text-slate-900 mt-2">brillantlukas@gmail.com</p>
                    </div>
                </div>
            </div>

            <div className="relative max-w-4xl mx-auto mt-14 rounded-2xl border border-slate-300/60 bg-gradient-to-br from-slate-900 to-slate-800 text-white p-8 md:p-12">
                <div className="text-center space-y-6">
                    <h2 className="text-3xl md:text-4xl font-black">Currently looking for an internship abroad</h2>
                    <p className="text-lg text-slate-200">2027 work-study opportunity in web or software development</p>
                    
                    <div className="flex flex-wrap gap-4 justify-center pt-4">
                        <a 
                            href="/Brillant_Lukas_CV.pdf" 
                            download 
                            className="px-6 py-3 bg-white text-slate-900 font-bold rounded-xl hover:-translate-y-1 transition-transform"
                        >
                            Download CV
                        </a>
                        <a 
                            href="mailto:brillantlukas@gmail.com" 
                            className="px-6 py-3 border-2 border-white text-white font-bold rounded-xl hover:bg-white/10 transition-all"
                        >
                            Contact Me
                        </a>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Home;
